import { UploadAsInvoice, nameToClass } from "../domain/WorkflowTemplate"
import { WorkflowTemplateRepository } from "../domain/WorkflowRepositories"
import { WorkflowTemplateEditorScreenData } from "../domain/WorkflowTemplateEditorScreenData"
import { OtherDocumentRepository } from "../domain/OtherDocumentRepository"
import { EntityTypeRepository } from "../../entities/domain/Entities"
import { DOCS_FIELD_MAP_SHOW } from "../../document/domain/Document"
import { re } from "mathjs"
import { get_tree_from_schema } from "../../entities/domain/GetTreeFromSchema"
import { SET_THIRD_PARTY_VALUES } from "@/store/modules/cookies"
export class WorkflowTemplateEditorComponent{
    
    workflow_repo:WorkflowTemplateRepository
    screen_data: WorkflowTemplateEditorScreenData
    other_doc_repo: OtherDocumentRepository
    entity_type_repo:EntityTypeRepository
  
    constructor(workflow_repo:WorkflowTemplateRepository, screen_data:WorkflowTemplateEditorScreenData, other_doc_repo: OtherDocumentRepository, entity_type_repo:EntityTypeRepository){ 
        this.workflow_repo = workflow_repo
        this.screen_data = screen_data
        this.other_doc_repo = other_doc_repo
        this.entity_type_repo = entity_type_repo
    }

    async mount(workflow_id) {
        if (workflow_id) {
            await this.fetchWorkflow(workflow_id)
        }
        this.screen_data.availableUsers = await this.workflow_repo.get_available_users()
        this.screen_data.availableEntityTypes = await this.entity_type_repo.get_my_types()
        let universal_aux_types = await this.entity_type_repo.get_aux_workflow_editor_types()
        for (let type of universal_aux_types){
            this.screen_data.availableEntityTypes.push(type)
        }
        let res = await this.workflow_repo.get_workflow_templates()
        console.log(res)
        this.screen_data.availableWorkflows.push(...Object.values(res));
        this.screen_data.availableStages = []
        for(let key of Object.keys(nameToClass)){
            this.screen_data.availableStages.push({
                'value': key,
                'name': DOCS_FIELD_MAP_SHOW[key]
            })
        }
        if (this.screen_data.workflow.input_entity_type_uuid){
            this.screen_data.workflow_input = 'params'
        }
        this.screen_data.availableTypes = await this.other_doc_repo.getAvailableTypes()
    }

    async fetchWorkflow(workflow_id){
        let wf = await this.workflow_repo.find_by_id(workflow_id)
        this.screen_data.workflow = wf
    }

    addStage(){
        let newStage = null
        if(this.screen_data.newStageName){
            let stage_class = nameToClass[this.screen_data.newStageName]
            newStage = stage_class.createEmpty() // cada classe defineix com es crea la instancia buida
            newStage.calculatePrice()
            this.screen_data.workflow.stages.push(newStage)
            if( stage_class.need_detail ){
                this.screen_data.selectedStage = newStage
                this.screen_data.selectedStageIndex = this.screen_data.workflow.stages.length - 1
                this.screen_data.myCurrentBagOfInstances = this.get_current_bag(this.screen_data.selectedStageIndex)
                this.screen_data.showStageDetails = true
            }
            // if(this.screen_data.newStageUser && this.screen_data.newStageName == 'WaitForApproval'){
            //     newStage.username = this.screen_data.newStageUser
            // }
        }
        
        this.screen_data.addStageDialog = false
        this.screen_data.newStageName = ''
        // this.screen_data.newStageUser = ''
        this.screen_data.showErrors = false
    }

    removeStage(stage){
        this.screen_data.workflow.stages = this.screen_data.workflow.stages.filter(s => s !== stage)
    }

    async saveWorkflow(){
        this.screen_data.loadingSave = true
        if(this.screen_data.workflow.validate()){
            if (this.screen_data.workflow.stages.length > 0) {
                this.screen_data.workflow.stages.forEach(stage => stage.calculatePrice())
            }
            let res = await this.workflow_repo.save_workflow_template(this.screen_data.workflow)
            if (res && res['status'] == 'ok') {
                await this.fetchWorkflow(res['wf_id'])
                this.screen_data.success_message('Workflow guardado correctamente')
            } else {
                this.screen_data.error_message('Error al guardar el workflow')
            }
        } else {
            this.screen_data.showErrors = true
            this.screen_data.showErrorsDialog = true
        }
        this.screen_data.loadingSave = false
    }


    

    get_entity_type_tree(uuid){
        let e_type = this.screen_data.availableEntityTypes.find(e => e.uuid == uuid)
        if (!e_type){
            return null
        }
        else{
            let schema = e_type.schema
            let tree = get_tree_from_schema(schema)
            return tree
        }

    }

    compute_bag_of_instances_story(){
        let my_bag_story = [];
        for (let i in this.screen_data.workflow.stages){
            my_bag_story.push({})
        }
        for (let i in this.screen_data.workflow.stages){
            let stage = this.screen_data.workflow.stages[i];
            if ((stage as any).save_as_key && (stage as any).entity_type_id){
                my_bag_story[i][(stage as any).save_as_key] = this.get_entity_type_tree((stage as any).entity_type_id);
            }
            else if((stage as any).save_list_key && (stage as any).entity_type_id){
                my_bag_story[i][(stage as any).save_list_key] = [this.get_entity_type_tree((stage as any).entity_type_id)]
            }
        }
        return my_bag_story
    }

    default_bag(){
        if(this.screen_data.workflow_input == 'document'){
            return {'empresa':{'id':null}, 'documento':{'id':null, 'uuid':null, 'num_pages':null, 'rendered_text':null, 'path':null,'user_id':null, 'type':null, 'original_file_name':null}}
        }
        else if(this.screen_data.workflow_input == 'params'){
            return {'empresa':{'id':null}, 'params':this.get_entity_type_tree(this.screen_data.workflow.input_entity_type_uuid)}
        }
        else{
            return {'empresa':{'id':null}}
        }
    }

    get_current_bag(curr_i){
        let story = this.compute_bag_of_instances_story()
        let my_bag = this.default_bag()
        for (let i in story){
            if (i < curr_i){
                let inst = story[i]
                if (Object.keys(inst).length > 0){
                    let key = Object.keys(inst)[0]
                    my_bag[key] = inst[key]
                }
            }
        }
        return my_bag
    }

    showDetail(stage, index) {
        let stage_class = nameToClass[stage.name]
        if (!stage || (stage && !stage_class.need_detail)) {
            this.screen_data.showStageDetails = false;
        }
        else{
            this.screen_data.showStageDetails = true;
        }
        this.screen_data.selectedStage = stage;
        this.screen_data.selectedStageIndex = index;
        this.screen_data.myCurrentBagOfInstances = this.get_current_bag(index)
    }

}